module.exports = __webpack_public_path__ + "img/promo.cd846062.svg";